export default class SendunitPool {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      name: '',
      quality: ''
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  getJSON() {
    return {
      id: this.id,
      name: this.name,
      quality: this.quality
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/sendunitPool/model.js